import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'camelCaseToNormal'})
export class CamelCaseToNormal implements PipeTransform {
  transform(value: string, args: string[] = []): any {
    if (!value) return value;
    return value.replace(/([A-Z])/g, ' $1')
     .replace(/^./, function(str){ return str.toUpperCase(); })
  }
}

